import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxScrollTopModule } from 'ngx-scrolltop';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { ModalComponentComponent } from './components/layouts/modal-component/modal-component.component';
import { NavbarStyleThreeComponent } from './components/layouts/navbar-style-three/navbar-style-three.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { SidebarComponent } from './components/layouts/sidebar/sidebar.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { HomeDemoEightComponent } from './components/pages/home-demo-eight/home-demo-eight.component';
import { HomeDemoTwelveComponent } from './components/pages/home-demo-twelve/home-demo-twelve.component';
import { HomeComponent } from './components/pages/home/home.component';
import { LoginComponent } from './components/pages/login/login.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { NoticeComponent } from './components/pages/notice/notice.component';

import { HttpClientModule } from '@angular/common/http';
import { EmitterService } from './EmitterService';
import { NameGhangePipe } from './namechange.pipe';
import { AppService } from './app.service';
import { AdministrationComponent } from './components/pages/administration/administration.component';
import { AboutAsideComponent } from './components/pages/about-aside/about-aside.component';
import { DwClubComponent } from './components/pages/dw-club/dw-club.component';
import { AcademicAsideComponent } from './components/pages/academic-aside/academic-aside.component';
import { TemplatePageComponent } from './components/pages/template-page/template-page.component';
import { LayoutDocumentListComponent } from './components/layouts/layout-document-list/layout-document-list.component';
import { LayoutDocumentSingleComponent } from './components/layouts/layout-document-single/layout-document-single.component';
import { LayoutImageListComponent } from './components/layouts/layout-image-list/layout-image-list.component';
import { LayoutImageMultipleComponent } from './components/layouts/layout-image-multiple/layout-image-multiple.component';
import { LayoutImageSingleComponent } from './components/layouts/layout-image-single/layout-image-single.component';
import { NewAndEventsComponent } from './components/pages/new-and-events/new-and-events.component';
import { NewAndEventsItemsComponent } from './components/pages/new-and-events-items/new-and-events-items.component';
import { VideoFolderComponent } from './components/pages/video-folder/video-folder.component';
import { VideoGalleryComponent } from './components/pages/video-gallery/video-gallery.component';
import { ImageGalleryComponent } from './components/pages/image-gallery/image-gallery.component';
import { ImageFolderComponent } from './components/pages/image-folder/image-folder.component';
import { SafePipe } from './utils/safe.pipe';
import { DynamicNewsAndEventComponent } from './components/pages/dynamic-news-and-event/dynamic-news-and-event.component';
import { AdmissionSghscComponent } from './components/pages/admission-sghsc/admission-sghsc.component';
import { LibraryComponent } from './components/pages/library/library.component';
import { ComputerClubComponent } from './components/pages/computer-club/computer-club.component';

import { PhysicsLabComponent } from './components/pages/physics-lab/physics-lab.component';
import { BiologyLabComponent } from './components/pages/biology-lab/biology-lab.component';
import { ChemistryLabComponent } from './components/pages/chemistry-lab/chemistry-lab.component';
import { MultimediaClassroomComponent } from './components/pages/multimedia-classroom/multimedia-classroom.component';
import { AchievementsComponent } from './components/pages/achievements/achievements.component';
import { AchievementsItemComponent } from './components/pages/achievements-item/achievements-item.component';
import { AllChiefPatronsComponent } from './components/pages/all-chief-patrons/all-chief-patrons.component';
import { AllChairmansComponent } from './components/pages/all-chairmans/all-chairmans.component';
import { AllPrincipalsComponent } from './components/pages/all-principals/all-principals.component';
import { TeacherInformationComponent } from './components/pages/teacher-information/teacher-information.component';
import { StaffInformationComponent } from './components/pages/staff-information/staff-information.component';
import { AcademicWingsCollegeComponent } from './components/pages/academic-wings-college/academic-wings-college.component';
import { AcademicWingsBanglaVersionComponent } from './components/pages/academic-wings-bangla-version/academic-wings-bangla-version.component';
import { AcademicWingsEnglishVersionComponent } from './components/pages/academic-wings-english-version/academic-wings-english-version.component';
import { LeadershipComponent } from './components/pages/leadership/leadership.component';
@NgModule({
    declarations: [
        AppComponent,
        PreloaderComponent,
        SidebarComponent,
        FooterComponent,
        NotFoundComponent,
        ContactComponent,
        HomeComponent,
        HomeDemoEightComponent,
        NoticeComponent,
        LoginComponent,
        HomeDemoTwelveComponent,
        NavbarStyleThreeComponent,
        ModalComponentComponent,
        NameGhangePipe,
        AdministrationComponent,
        AboutAsideComponent,
        DwClubComponent,
        AcademicAsideComponent,
        TemplatePageComponent,
        LayoutDocumentListComponent,
        LayoutDocumentSingleComponent,
        LayoutImageListComponent,
        LayoutImageMultipleComponent,
        LayoutImageSingleComponent,
        NewAndEventsComponent,
        NewAndEventsItemsComponent,
        VideoFolderComponent,
        VideoGalleryComponent,
        ImageGalleryComponent,
        ImageFolderComponent,
        SafePipe,
        DynamicNewsAndEventComponent,
        AdmissionSghscComponent,
        LibraryComponent,
        ComputerClubComponent,
        PhysicsLabComponent,
        BiologyLabComponent,
        ChemistryLabComponent,
        MultimediaClassroomComponent,
        AchievementsComponent,
        AchievementsItemComponent,
        AllChiefPatronsComponent,
        AllChairmansComponent,
        AllPrincipalsComponent,
        TeacherInformationComponent,
        StaffInformationComponent,
        AcademicWingsCollegeComponent,
        AcademicWingsBanglaVersionComponent,
        AcademicWingsEnglishVersionComponent,
        LeadershipComponent,
    ],

    providers: [AppService, EmitterService],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgxScrollTopModule,
        HttpClientModule,
    ],
})
export class AppModule {}
